module.exports = __webpack_public_path__ + "static/media/中高エレクトロニクス研究部.34b3a12e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/exhibition/中高エレクトロニクス研究部.png
// module id = 310
// module chunks = 10